export default "<p>compras-proveedor works!</p>\n"